import { PText, PFlex, PFlexItem } from '@porsche-design-system/components-react'
import clsx from 'clsx'
import React from 'react'

import Actions from '../Actions/Actions'

import { TEXTS } from '../../../config/texts'
import { PortalContext } from '../../../utils/PortalContext'

import PAGRating from '../../../Types'
import styles from './modules.module.css'

type Props = {
  module: PAGRating.Module
}

const Modules = ({ module }: Props) => {
  const { openDrawer, drawerData, setDrawerData, setOpenDrawer, setDrawerContent } = React.useContext(PortalContext)

  const openDetailsInDrawerModule = (module: PAGRating.Module) => {
    return function () {
      setDrawerData(module)
      setOpenDrawer(true)
      setDrawerContent('DetailsApp')
    }
  }

  return (
    <PFlex
      className={clsx(styles.modules, {
        [styles.active]: openDrawer && drawerData.appInformation?.configId === module.configId
      })}
    >
      <PFlexItem flex='auto' className={styles.hoverable} onClick={openDetailsInDrawerModule(module)}>
        <PText className={styles.appTitle}>{module.moduleDescription}</PText>

        <PText color='neutral-contrast-medium' className={styles.appTitle}>
          {module.appId === 'APP-' ? '' : module.appId}
        </PText>
        {module.test && (
          <PText color='neutral-contrast-medium' size='x-small' className={styles.appTitle}>
            {TEXTS.MODULES_TEST_BADGE}
          </PText>
        )}
      </PFlexItem>
      <Actions className={styles.actions} appData={module} />
    </PFlex>
  )
}

export default Modules
